<app-icon name="circle_done" centered />
